import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { googleSheetFormItemName } from '../../../utils'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'

const EditGoogleSheetBody: React.FC = () => {
  const help = HelpMessage.PayItems.Manage.Connections.GoogleSheet
  return (
    <CIMSSection title="Google Sheet">
      <CIMSFormItem
        help={help.PayItemColumnKey}
        label="Pay Item Column Key"
        name={googleSheetFormItemName('payItemColumnKey')}
        requiredMessage="Please enter a pay item column key"
      >
        <Input allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        help={help.DocumentId}
        label="Document ID"
        name={googleSheetFormItemName('documentId')}
        requiredMessage="Please enter a document ID"
      >
        <Input allowClear />
      </CIMSFormItem>
      <CIMSFormItem
        help={help.SheetId}
        label="Sheet ID"
        name={googleSheetFormItemName('sheetId')}
        requiredMessage="Please enter a sheet ID"
      >
        <Input allowClear />
      </CIMSFormItem>
    </CIMSSection>
  )
}

export default EditGoogleSheetBody
